export const PensionMode = {
  API: 'api',
  SUBMISSION: 'submission',
} as const;

export type PensionMode = typeof PensionMode[keyof typeof PensionMode];